<template>
    <div class="items-center p-6">
        <div class="flex items-center pb-3">
            <div class="chart-inner-headline pl-4">{{label_1}}<span class="text-gray-400">{{label_2}}</span></div>
            <div class="ml-auto flex">
                <div class="text-3xl ml-auto">{{salesValue | toCurrency}}</div>
                <span class="text-2xl mx-2 mt-1">|</span>
                <div class="text-3xl text-gray-400">{{floorSalesValue | toCurrency}}</div>
            </div>
        </div>
        <div class="">
            <total-floor-sales-today-stacked-bar
                :data="this.salesData"
                :labels="[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]"
                :chart-label="$t('pages.controlpanel.index.controls.total_fs_today_label' + this.$page.props.tenant.labels_key)"
                :label-demand="$t('pages.controlpanel.index.controls.label_demand')"
                :label-sales="$t('pages.controlpanel.index.controls.label_sales')"
                :width="400"
                :height="200"
            />
        </div>
    </div>
</template>

<script>
import TotalFloorSalesTodayStackedBar from "@/Shared/Charts/TotalFloorSalesTodayStackedBar";

export default {
    components: {
        TotalFloorSalesTodayStackedBar
    },
    props: {
        label_1: String,
        label_2: String,
        floorSalesValue: Number,
        salesValue: Number,
        salesData: Array
    }
}
</script>
